class ProductOther {
    constructor() {
        this.productOtherElement = document.getElementById('product-other');
        if (this.productOtherElement) {
            this.checkTabContent();
        }
    }

    checkTabContent() {
        // Controlla il contenuto di entrambe le tab
        const configurationTab = document.getElementById('configuration');
        const forYouTab = document.getElementById('for_you');

        const configurationContent = configurationTab ? configurationTab.querySelector('.swiper-wrapper').children.length : 0;
        const forYouContent = forYouTab ? forYouTab.querySelector('.swiper-wrapper').children.length : 0;

        // Se entrambe le tab sono vuote, nascondi l'intera sezione
        if (configurationContent === 0 && forYouContent === 0) {
            this.productOtherElement.style.display = 'none';
            this.productOtherElement.classList.add('is-hidden');
            return;
        }

        // Se product-other è visibile, rimuovi la classe is-hidden
        this.productOtherElement.classList.remove('is-hidden');

        // Gestisci la visibilità delle singole tab
        this.handleTabVisibility('configuration', configurationContent);
        this.handleTabVisibility('for_you', forYouContent);

        // Inizializza solo se c'è contenuto
        if (configurationContent > 0) {
            this.initSwiper_two();
        }
        if (forYouContent > 0) {
            this.initSwiper();
        }

        this.setupTabs();
    }

    handleTabVisibility(tabId, contentCount) {
        const tabElement = document.querySelector(`[data-tab="${tabId}"]`);
        const tabContent = document.getElementById(tabId);

        if (contentCount === 0) {
            // Nascondi la tab e il suo contenuto
            if (tabElement) { tabElement.style.display = 'none'; tabElement.classList.remove('active'); }
            if (tabContent) { tabContent.style.display = 'none'; tabElement.classList.add('d-hidden'); }
        } else {
            // Mostra la tab e il suo contenuto
            if (tabElement) { tabElement.style.display = ''; tabElement.classList.add('active'); }
            if (tabContent) { tabContent.style.display = ''; tabElement.classList.remove('d-hidden'); }
        }
    }

    initSwiper() {
        this.swiper = new Swiper('.carousel-for-you', {
            slidesPerView: 'auto',
            spaceBetween: 10,
            freeMode: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }

    initSwiper_two() {
        this.swiper_two = new Swiper('.carousel-configuration', {
            slidesPerView: 'auto',
            spaceBetween: 10,
            freeMode: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }

    setupTabs() {
        document.querySelectorAll('.tab').forEach(tab => {
            tab.addEventListener('click', () => {
                const tabId = tab.getAttribute('data-tab');
                document.querySelectorAll('.tab-content').forEach(content => {
                    content.classList.add('d-hidden'); // Nascondi tutti i contenuti
                });
                document.getElementById(tabId).classList.remove('d-hidden') // Mostra il contenuto della tab selezionata

                // Aggiungi la classe active all'elemento cliccato e rimuovila dagli altri
                document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
                tab.classList.add('active');
            });
        });
    }
}

// Inizializza la classe solo se l'elemento è presente
new ProductOther();